import { Form, Formik } from "formik"
import { changePassword } from "helpers/requests"
import PropTypes from "prop-types"
import React, { useState } from "react"
import SweetAlert from "react-bootstrap-sweetalert"
import ReCAPTCHA from "react-google-recaptcha"
import { Link } from "react-router-dom"
import {
  Button,
  Card,
  CardBody,
  Col,
  FormGroup,
  Input,
  InputGroup,
  Label,
  Row,
} from "reactstrap"
import * as Yup from "yup"

const initialStates = {
  feedbackModal: {
    open: false,
    message: "",
    title: "",
  },
  warningFeedbackModal: {
    open: false,
    message: "",
    title: "",
  },
}

const user = JSON.parse(localStorage.getItem("userData")) || {}

const ChangePassword = () => {
  const [loading, setLoading] = useState(null)
  const [password1Type, setPassword1Type] = useState("password")
  const [password2Type, setPassword2Type] = useState("password")
  const [disableButton, setDisableButton] = useState(false)
  const [feedbackModal, setFeedbackModal] = useState(
    initialStates.feedbackModal
  )
  const [warningFeedbackModal, setWarningFeedbackModal] = useState(
    initialStates.warningFeedbackModal
  )

  const closeFeedbackModal = () => {
    setFeedbackModal(initialStates.feedbackModal)
  }
  const closeWarningFeedbackModal = () => {
    setWarningFeedbackModal(initialStates.warningFeedbackModal)
  }

  function onCaptchaChange(value) {
    console.log("Captcha value:", value)
    setDisableButton(true)
  }

  const handlePassword1Type = () => {
    if (password1Type === "text") setPassword1Type("password")
    else setPassword1Type("text")
  }
  const handlePassword2Type = () => {
    if (password2Type === "text") setPassword2Type("password")
    else setPassword2Type("text")
  }

  return (
    <React.Fragment>
      <Card className="overflow-hidden">
        <div className="bg-primary">
          <Row>
            <Col>
              <div className="text-white p-4">
                <p>Change Your Password</p>
              </div>
            </Col>
          </Row>
        </div>
        <CardBody className="pt-2 px-0">
          <div className="pt-3">
            <Formik
              initialValues={{
                currentPassword: "",
                newPassword: "",
              }}
              validationSchema={Yup.object({
                currentPassword: Yup.string().required("Required"),
                newPassword: Yup.string()
                  .min(8, "Must be 8 characters or more")
                  .max(32, "Must not exceed 32 characters")
                  .matches(/([0-9])/, "Must contain at least one number")
                  .matches(
                    /([a-z])/,
                    "Must contain at least one lowercase letter"
                  )
                  .matches(
                    /([A-Z])/,
                    "Must contain at least one uppercase letter"
                  )
                  .matches(
                    /([@#$%!])/,
                    "Must contain at least one special character (@#$%!)"
                  )
                  .required("Required"),
              })}
              onSubmit={async (values, { resetForm }) => {
                console.log(values)
                setLoading(true)
                const data = {
                  orgId: "939001",
                  userGlobalId: user?.userGlobalId,
                  currentPassword: values.currentPassword,
                  newPassword: values.newPassword,
                }

                const res = await changePassword(data)
                resetForm({ values: "" })
                setLoading(null)
                if (res === undefined) {
                  alert("Please check your internet connection")
                  setLoading(null)
                }
                if (res?.success === false) {
                  console.log(res)
                  setLoading(null)
                  setWarningFeedbackModal(prev => ({
                    ...prev,
                    open: true,
                    success: false,
                    error: true,
                    title: "Failed!",
                    message: res.message,
                  }))
                } else if (res?.success === true) {
                  console.log(res)
                  setFeedbackModal(prev => ({
                    ...prev,
                    open: true,
                    success: true,
                    error: false,
                    title: "Done!",
                    message: res.message,
                  }))
                }
              }}
            >
              {props => {
                return (
                  <Form className="form-horizontal">
                    <FormGroup>
                      <Label>Current Password</Label>
                      <InputGroup>
                        <Input
                          name="currentPassword"
                          type={password1Type}
                          className="form-control mx-0"
                          placeholder="Enter your current Password"
                          onChange={props.handleChange}
                          value={props.values.currentPassword}
                          onBlur={props.handleBlur}
                        />
                        <div
                          className="input-group-append"
                          style={{ cursor: "pointer" }}
                          onClick={handlePassword1Type}
                        >
                          <span className="input-group-text">
                            {password1Type === "text" ? (
                              <i class="fa fa-low-vision"></i>
                            ) : (
                              <i class="fa fa-eye" aria-hidden="true"></i>
                            )}
                          </span>
                        </div>
                      </InputGroup>
                      {props.touched.currentPassword &&
                      props.errors.currentPassword ? (
                        <p style={{ color: "red", fontSize: "11px" }}>
                          {props.errors.currentPassword}
                        </p>
                      ) : null}
                    </FormGroup>

                    <FormGroup>
                      <Label>New Password</Label>
                      <InputGroup>
                        <Input
                          name="newPassword"
                          type={password2Type}
                          className="form-control mx-0"
                          placeholder="Enter your new Password"
                          onChange={props.handleChange}
                          value={props.values.newPassword}
                          onBlur={props.handleBlur}
                        />
                        <div
                          className="input-group-append"
                          style={{ cursor: "pointer" }}
                          onClick={handlePassword2Type}
                        >
                          <span className="input-group-text">
                            {password2Type === "text" ? (
                              <i class="fa fa-low-vision"></i>
                            ) : (
                              <i class="fa fa-eye" aria-hidden="true"></i>
                            )}
                          </span>
                        </div>
                      </InputGroup>
                      {props.touched.newPassword && props.errors.newPassword ? (
                        <p style={{ color: "red", fontSize: "11px" }}>
                          {props.errors.newPassword}
                        </p>
                      ) : null}
                    </FormGroup>

                    <FormGroup className="select2-container">
                      <ReCAPTCHA
                        sitekey={process.env.REACT_APP_RECAPTCHA_SITE_KEY}
                        onChange={onCaptchaChange}
                      />
                    </FormGroup>

                    <FormGroup>
                      <div
                        className="mt-4"
                        style={{
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "space-around",
                        }}
                      >
                        <button
                          className="btn btn-primary waves-effect waves-light "
                          type="submit"
                          style={{ width: "42%" }}
                          disabled={!disableButton}
                        >
                          {loading ? "Submitting" : "Submit"}
                        </button>
                        <Button
                          style={{ width: "42%" }}
                          type="button"
                          color="link"
                        >
                          <Link to="/">
                            {loading ? "Cancelling" : "Cancel"}
                          </Link>
                        </Button>
                      </div>
                      <i style={{ color: "#000", fontSize: "11px" }}>
                        Kindly click on the captcha field to enable the "Submit"
                        button
                      </i>
                    </FormGroup>
                  </Form>
                )
              }}
            </Formik>
            {feedbackModal.open && (
              <SweetAlert
                title={feedbackModal.title}
                success
                confirmBtnBsStyle="success"
                onConfirm={closeFeedbackModal}
              >
                {feedbackModal.message}
              </SweetAlert>
            )}
            <>
              {warningFeedbackModal.open && (
                <SweetAlert
                  title={warningFeedbackModal.title}
                  danger
                  confirmBtnBsStyle="danger"
                  onConfirm={closeWarningFeedbackModal}
                >
                  {warningFeedbackModal.message}
                </SweetAlert>
              )}
            </>
          </div>
        </CardBody>
      </Card>
    </React.Fragment>
  )
}

ChangePassword.propTypes = {
  t: PropTypes.any,
}

export default ChangePassword
